import * as _ from "lodash";
import http from "../constant/api";

export const profileRouterService = {
  readProfileRouterByProfileId: async (profileId) => {
    const result = await http.get(
      `/api/profile-router/read/profile-id/${profileId}`
    );

    return result;
  },
  addProfileRouter: async (data) => {
    const result = await http.post(`/api/profile-router/add`, data);

    return result;
  },
  editProfileRouter: async (id, data) => {
    const result = await http.put(`/api/profile-router/${id}/edit`, data);

    return result;
  },
  removeProfileRouter: async (id) => {
    const result = await http.delete(`/api/profile-router/${id}/remove`);

    return result;
  },
};
